export default {
  ekyc: {
    title: '请用手机浏览器扫描下方二维码进行ekyc认证',
    btn: '查看ekyc是否通过认证',
    tip: '如果已经完成扫码认证，可查看是否已通过认证',
    success: 'EKYC已经完成',
    reload: '再次ekyc认证',
    userInfo: '用户信息',
    fullName: '姓名',
    address: '地址',
    birthday: '生日',
    expireDate: '失效日期',
    images: '照片'
  }
}
